import angular from 'angular';
import 'angular-animate';
import '@uirouter/angularjs';
import 'angular-loading-bar';
import 'angular-translate';
import 'angular-translate-loader-static-files';
import 'angular-bootstrap';
import 'angular-growl-v2';
import 'angular-ui-tree';

// Importy lokalne
import './login/routing-config';
import './common/commonModule';
import languageServiceModule from './common/languageService';
import './login/loginModule';
import './admin/adminModule';
import './data_management/dataManagementModule';
import './superuser/superuserModule';
import './application/applicationModule';
import './login/loginControllers';
import httpInterceptorModule from './common/httpInterceptor';
import path from "path";

const httpInterceptorName = httpInterceptorModule.name;

const appsoup = angular.module('appsoupApp', [
    'ngAnimate',
    'adminModule',
    'angular-growl',
    'angular-loading-bar',
    'applicationModule',
    'commonModule',
    'dataManagementModule',
    'languageServiceModule',
    'loginModule',
    'ncy-angular-breadcrumb',
    'pascalprecht.translate',
    'superuserModule',
    'ui.bootstrap',
    'ui.router',
    'ui.tinymce',
    'ui.tree',
    'flow',
    'ngFileUpload',
    'appsoup.httpInterceptor'
]);

// Pomocnicze funkcje
angular.isNullOrUndefined = (val) => angular.isUndefined(val) || val === null;
angular.isDefinedNotNull = (val) => angular.isDefined(val) && val !== null;
angular.isDefinedNotEmpty = (val) => angular.isDefined(val) && val !== '';
angular.isUndefinedNullOrEmpty = (val) => angular.isUndefined(val) || val === null || val === '';

angular.openInNewTab = function (val) {
    var link = angular.element('<a href="' + val + '" target="_blank"></a>');
    angular.element(document.body).append(link); //eslint-disable-line
    link[0].click();
    link.remove();
};

angular.setUpEnable = function (data, key) {
    if (data[key].order < 0) {
        return false;
    }
    if (data[key - 1]) {
        return data[key - 1].order > 0;
    }

    return false;
};

angular.setDownEnable = function (data, key) {
    if (data[key].order < 0) {
        return false;
    }
    if (data[key + 1]) {
        return data[key + 1].order > 0;
    }

    return false;
};

angular.datepickerConfigs = function (key1, key2) {
    key1.startingDay = 1;
    key1.showWeeks = false;
    key2.datepickerPopup = "yyyy-MM-dd";
    key2.showButtonBar = false;
};

angular.changeOrderResponse = function (data, key1, key2) {
    var tmp_order = data[key1].order;
    data[key1].order = data[key2].order;
    data[key2].order = tmp_order;

    var tmp = angular.copy(data[key1]);
    data[key1] = angular.copy(data[key2]);
    data[key2] = tmp;

    return data;
};

angular.changeOrderExtreme = function (data, key1, direction) {
    const oldData = angular.copy(data);

    if (direction === 'bottom') {
        data.push(data.shift());
    }
    if (direction === 'top') {
        data.unshift(data.pop());
    }

    const len = data.length;
    for (let i = 0; i < len; i++) {
        data[i].order = oldData[i].order;
    }

    return data;
};

angular.getTinymceOptionsSmall = function () {
    return {
        height: 200,
        plugins: [ 'advlist autolink lists link', 'searchreplace wordcount visualblocks visualchars code fullscreen' ],
        menubar: false,
        toolbar: 'bold italic underline | bullist numlist | link',
        force_br_newlines: true,
        force_p_newlines: false,
        forced_root_block: ''
    };
};

angular.getTinymceOptions = function ($modal, height) {
    height = angular.isDefinedNotEmpty(height) ? height : 500;

    return {
        height: height,
        plugins: [
            'advlist autolink lists link image charmap print preview hr anchor pagebreak',
            'searchreplace wordcount visualblocks visualchars code fullscreen',
            'insertdatetime media nonbreaking save table contextmenu directionality',
            'paste textcolor colorpicker textpattern imagetools codesample toc'
        ],
        valid_children : '+body[style]',
        toolbar1: 'undo redo | insert | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image',
        toolbar2: 'print preview media | forecolor backcolor | codesample',
        image_advtab: true,
        content_css: [ '//fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i' ],
        image_title: true,
        automatic_uploads: true,
        file_browser_callback: function (field_name, url, type, win) {
            if (type == 'image') {
                var modalInstance = $modal.open({
                    templateUrl: 'views/common/components/modals/libraryModal.tpl.html',
                    controller: 'LibrariesModalController',
                    size: 'xlg',
                    animation: true,
                    windowClass: 'zindex'
                });

                modalInstance.result.then(function (file) {
                    win.document.getElementById(field_name).value = file.direct_url;
                }).catch(() => {});
            }
        },
        file_browser_callback_types: 'image',
        default_link_target: '_blank',
        target_list: [{title: 'Same window', value: '_self'}, {title: 'New window', value: '_blank'}]
    };
};

angular.getTinymceOptionsBr = function ($modal, height) {
    var tinymce = angular.getTinymceOptions($modal, height);
    tinymce.force_br_newlines = true;
    tinymce.force_p_newlines = false;
    tinymce.forced_root_block = '';

    return tinymce;
};

angular.selectElement = function (data, id) {
    var index = data.indexOf(id);
    if (index !== -1) {
        data.splice(index, 1);
    } else {
        data.push(id);
    }

    return data;
};

angular.checkSelectedElements = function (data, item) {
    if (data.length > 0) {
        var checked = true;
        angular.forEach(item.$data, function (v) {
            var elementId = v.id;
            var index = data.indexOf(elementId);
            if (index === -1) {
                checked = false;
            }
        });

        return checked;
    } else {
        return false;
    }
};

angular.selectAllElements = function (data, item) {
    if (item.allCheckBox) {
        angular.forEach(item.$data, function (v) {
            var elementId = v.id;
            var index = data.indexOf(elementId);
            if (index === -1) {
                data.push(elementId);
            }
        });
    } else {
        angular.forEach(item.$data, function (v) {
            var elementId = v.id;
            var index = data.indexOf(elementId);
            if (index !== -1) {
                data.splice(index, 1);
            }
        });
    }

    return data;
};

// Konfiguracja
appsoup.config(['$httpProvider', '$urlRouterProvider', '$translateProvider', '$breadcrumbProvider', 'growlProvider', function ($httpProvider, $urlRouterProvider, $translateProvider, $breadcrumbProvider, growlProvider) {
    $urlRouterProvider.otherwise('/login');

    $translateProvider.useStaticFilesLoader({
        prefix: 'assets/i18n/',
        suffix: '.json'
    });

    $translateProvider
        .registerAvailableLanguageKeys([
            'pl',
            'en',
            'de'
        ], {
            'pl_PL': 'pl',
            'en_US': 'en',
            'en_UK': 'en',
            'de_DE': 'de',
            'de_CH': 'de'
        })
        .determinePreferredLanguage();

    $breadcrumbProvider.setOptions({
        prefixStateName: 'appsoup',
        includeAbstract: true,
        template: `<ol class="breadcrumb">
        <li ng-repeat="step in steps" ng-class="{active: $last}" ng-switch="$last || !!step.abstract">
        <a ng-switch-when="false" href="{{step.ncyBreadcrumbLink}}">{{step.ncyBreadcrumbLabel | translate}}</a>
        <span ng-switch-when="true">{{step.ncyBreadcrumbLabel | translate}}</span>
        </li>
        </ol>`
    });

    growlProvider.globalTimeToLive(5000);
    growlProvider.globalDisableCountDown(true);

    $httpProvider.interceptors.push('AppsoupHttpInterceptor');
}]);

appsoup.run(['$rootScope', '$templateCache', function ($rootScope, $templateCache) {
    $rootScope.doneLoading = function () {
        $rootScope.doingResolve = false;
    };

    // UI-SELECT
    $templateCache.put("appsoup/choices.tpl.html", "<ul class=\"ui-select-choices ui-select-choices-content select2-results\"><li class=\"ui-select-choices-group\" ng-class=\"{'select2-result-with-children': $select.isGrouped}\"><div ng-show=\"$select.isGrouped\" class=\"ui-select-choices-group-label select2-result-label\">{{$group.name}}</div><ul ng-class=\"{'select2-result-sub': $select.isGrouped, 'select2-result-single': !$select.isGrouped}\"><li class=\"ui-select-choices-row\" ng-class=\"{'select2-highlighted': $select.isActive(this), 'select2-disabled': $select.isDisabled(this)}\"><div class=\"select2-result-label ui-select-choices-row-inner\"></div></li></ul></li></ul>");
    $templateCache.put("appsoup/match-multiple.tpl.html", "<span class=\"ui-select-match\"><li class=\"ui-select-match-item select2-search-choice\" ng-repeat=\"$item in $select.selected\" ng-class=\"{'select2-search-choice-focus':$select.activeMatchIndex === $index}\"><span uis-transclude-append=\"\"></span> <a href=\"javascript:;\" class=\"ui-select-match-close select2-search-choice-close\" ng-click=\"$select.removeChoice($index)\" tabindex=\"-1\"><i class=\"li-close\"></i></a></li></span>");
    $templateCache.put("appsoup/match.tpl.html", "<a class=\"select2-choice ui-select-match\" ng-class=\"{'select2-default': $select.isEmpty()}\" ng-click=\"$select.activate()\"><span ng-show=\"$select.searchEnabled && $select.isEmpty()\" class=\"select2-chosen\">{{$select.placeholder}}</span> <span ng-hide=\"$select.isEmpty()\" class=\"select2-chosen\" ng-transclude=\"\"></span> <span class=\"ui-select-clear\" ng-if=\"$select.allowClear && !$select.isEmpty()\" ng-click=\"$select.select(undefined)\"><i class=\"li-remove\"></i></span> <span class=\"select2-arrow ui-select-toggle\" ng-click=\"$select.toggle($event)\"><i class=\"{{ $select.open ? 'li-arrow-up' : 'li-arrow-down'}}\"></i></span></a>");
    $templateCache.put("appsoup/select-multiple.tpl.html", "<div class=\"ui-select-multiple select2 select2-container select2-container-multi\" ng-class=\"{'select2-container-active select2-dropdown-open': $select.open,\n                'select2-container-disabled': $select.disabled}\"><ul class=\"select2-choices\"><span class=\"ui-select-match\"></span><li class=\"select2-search-field\"><input type=\"text\" autocomplete=\"off\" autocorrect=\"off\" autocapitalize=\"off\" spellcheck=\"false\" class=\"form-control ui-select-search\" placeholder=\"{{getPlaceholder()}}\" ng-disabled=\"$select.disabled\" ng-hide=\"$select.disabled\" ng-model=\"$select.search\" ng-click=\"$select.activate()\" style=\"width: 34px;\"></li></ul><div class=\"select2-drop select2-with-searchbox select2-drop-active\" ng-class=\"{'select2-display-none': !$select.open}\"><div class=\"ui-select-choices\"></div></div></div>");
    $templateCache.put("appsoup/select.tpl.html", "<div class=\"select2 select2-container\" ng-class=\"{'select2-container-active select2-dropdown-open': $select.open,\n                'select2-container-disabled': $select.disabled,\n                'select2-container-active': $select.focus }\"><div class=\"ui-select-match\"></div><div class=\"select2-drop select2-with-searchbox select2-drop-active\" ng-class=\"{'select2-display-none': !$select.open}\"><div class=\"select2-search\" ng-show=\"$select.searchEnabled\"><div class=\"input-group\"><input type=\"text\" autocomplete=\"off\" autocorrect=\"off\" autocapitalize=\"off\" spellcheck=\"false\" class=\"ui-select-search form-control\" ng-model=\"$select.search\" placeholder=\"{{'MODULES.APPLICATIONS.PLACEHOLDER.START_TYPING' | translate}}\"><span class=\"input-group-addon\"><i class=\"li-search\"></i></span></div></div><div class=\"ui-select-choices\"></div></div></div>");

    // ng-table
    $templateCache.put('ng-table/pager.html', '<div class="ng-cloak ng-table-pager"> <div ng-if="params.settings().counts.length" class="ng-table-counts btn-group pull-right"><button ng-repeat="count in params.settings().counts" type="button" ng-class="{\'active\':params.count()==count}" ng-click="params.count(count)" class="btn btn-pager"> <span ng-bind="count"></span> </button> </div> <ul class="pagination ng-table-pagination"><li ng-class="{\'active\': page.number == params._params.page && page.type !== \'prev\' && page.type !== \'next\'}" ng-repeat="page in pages" ng-switch="page.type"> <a ng-switch-when="prev" ng-click="params.page(page.number)" href=""><i class="fa fa-arrow-left"></i></a> <a ng-switch-when="first" ng-click="params.page(page.number)" href=""><span ng-bind="page.number"></span></a> <a ng-switch-when="page" ng-click="params.page(page.number)" href=""><span ng-bind="page.number"></span></a> <a ng-switch-when="more" ng-click="params.page(page.number)" href="">&#8230;</a> <a ng-switch-when="last" ng-click="params.page(page.number)" href=""><span ng-bind="page.number"></span></a> <a ng-switch-when="next" ng-click="params.page(page.number)" href=""><i class="fa fa-arrow-right"></i></a> </li> </ul> </div> ');
}]);

//TODO remove

// appsoup.config(['$provide', function($provide) {
//     const origController = appsoup.controller;
//
//     appsoup.controller = function(name, constructor) {
//         if (name === 'controller') {
//             console.error('Rejestracja kontrolera o nazwie "controller" znaleziono tutaj:', new Error().stack);
//         }
//         return origController.apply(this, arguments);
//     };
//
//     $provide.decorator('$controller', ['$delegate', function($delegate) {
//         return function(constructor, locals, later, indent) {
//             let name = constructor;
//
//             if (Array.isArray(constructor)) {
//                 const last = constructor[constructor.length - 1];
//                 name = typeof last === 'function' ? (last.name || 'anonymous') : String(last);
//             } else if (typeof constructor === 'string') {
//                 name = constructor;
//             } else if (constructor && constructor.name) {
//                 name = constructor.name;
//             }
//
//             if (name === 'controller') {
//                 console.error('Tworzenie kontrolera "controller" stack trace:', new Error().stack);
//             }
//
//             return $delegate(constructor, locals, later, indent);
//         };
//     }]);
// }]);


export default appsoup;
